/* eslint-disable */
import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import type { SortOption } from '../../hooks/useRelease';

interface SortControlsProps {
  sortOption: SortOption;
  onSortChange: (sort: SortOption) => void;
}

export const SortControls: React.FC<SortControlsProps> = ({
  sortOption,
  onSortChange,
}) => {
  const labelId = 'sort-by-label';
  const selectId = 'sort-by-select';

  const handleFieldChange = (event: SelectChangeEvent) => {
    onSortChange({
      ...sortOption,
      field: event.target.value as SortOption['field'],
    });
  };

  const handleDirectionChange = (
    _event: React.MouseEvent<HTMLElement>,
    newDirection: 'asc' | 'desc' | null
  ) => {
    if (newDirection !== null) {
      onSortChange({
        ...sortOption,
        direction: newDirection,
      });
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel id={labelId}>Sort by</InputLabel>
        <Select
          value={sortOption.field}
          label="Sort by"
          labelId={labelId}
          id={selectId}
          onChange={handleFieldChange}
        >
          <MenuItem value="id">Ticket ID</MenuItem>
          <MenuItem value="status">Status</MenuItem>
          <MenuItem value="assignee">Assignee</MenuItem>
          <MenuItem value="title">Title</MenuItem>
        </Select>
      </FormControl>

      <ToggleButtonGroup
        value={sortOption.direction}
        exclusive
        onChange={handleDirectionChange}
        size="small"
        aria-label="sort direction"
      >
        <ToggleButton value="asc" aria-label="ascending">
          <ArrowUpward fontSize="small" />
        </ToggleButton>
        <ToggleButton value="desc" aria-label="descending">
          <ArrowDownward fontSize="small" />
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
